import { useEffect, useState } from "react";
import Popup from "components/Popup/popup";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import styles from "./Popup.module.css";
import "react-datepicker/dist/react-datepicker.css";
import { BookingList, EmployBookingList, ProcessBookingValues } from "modules/booking";
import { IoMdClose } from "react-icons/io";
import { formatDate, profileStatusLabels } from "utils/bookingPopup";
import { getintervalBookingsemploy } from "services/booking/get-interval-bookings-employ";
import { processBooking } from "services/booking/process-booking";
import ErrorFailed from "components/errorFailed/errorFailed";
import SuccessPopup from "components/successPopup/successPopup";

interface BookingPopupProps {
  isOpen: boolean;
  onClose: () => void;
  bookinglist: EmployBookingList;
}

export default function BookingsProcessPopup({ isOpen, onClose, bookinglist }: BookingPopupProps) {
  const [bookingData, setBookingData] = useState<BookingList[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState<ProcessBookingValues>({
    id: bookinglist.id,
    feedback: "",
    state: "",
    recurrenceDates: [
      bookinglist.recurrence_date_0,
      bookinglist.recurrence_date_1,
      bookinglist.recurrence_date_2,
      bookinglist.recurrence_date_3,
    ],

  });

  const [checkboxStates, setCheckboxStates] = useState<boolean[]>([
    bookinglist.recurrence_date_0_status === 'pending' || bookinglist.recurrence_date_0_status === 'confirmed',
    bookinglist.recurrence_date_1_status === 'pending' || bookinglist.recurrence_date_1_status === 'confirmed',
    bookinglist.recurrence_date_2_status === 'pending' || bookinglist.recurrence_date_2_status === 'confirmed',
    bookinglist.recurrence_date_3_status === 'pending' || bookinglist.recurrence_date_3_status === 'confirmed',
  ]);

  const fetchData = async () => {
    if (bookinglist.recurrence === 'serial') {
      try {
        const recurrenceDates = [
          bookinglist.recurrence_date_0,
          bookinglist.recurrence_date_1,
          bookinglist.recurrence_date_2,
          bookinglist.recurrence_date_3,
        ];
        const validDates = recurrenceDates.filter(date => date != null);
        const allBookingData: any[] = [];

        for (let date of validDates) {
          if (date) {
            const recDate = new Date(date);

            const rawBookingData = await getintervalBookingsemploy(recDate, recDate);

            if (rawBookingData.Kids_bookings_data) {
              const bookingData = rawBookingData.Kids_bookings_data.map((booking: any) => ({
                ...booking,
                name: `${booking.first_name} ${booking.last_name}`,
              }));
              allBookingData.push(...bookingData);
            }
          }
        }

        const uniqueBookingData = allBookingData.filter(
          (booking, index, self) =>
            index === self.findIndex(b => b.id === booking.id)
        );

        setBookingData(uniqueBookingData);

      } catch (error) {
        console.error("Fehler beim Abrufen der daten:", error);
      }
    }
  };
  useEffect(() => {
    fetchData();
  }, []);




  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleConfirm = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setIsLoading(true)
    const newFormValues = {
      ...formValues,
      checkboxStates,
      state: 'confirmed',

    };
    if (bookinglist.recurrence === 'serial' && !checkboxStates.some((status: boolean) => status)) {
      setError('Bitte wählen Sie mindestens ein Wiederholungsdatum aus.');
      setIsLoading(false);
      return;
    }
    setFormValues(newFormValues);

    try {
      const res = await processBooking(newFormValues);


      if (!res.success) {
        setError(res.message || 'Es ist ein Fehler bei der Buchung aufgetreten. Bitte versuchen Sie es erneut.');
        setIsLoading(false)

      } else {
        setIsSuccessPopupOpen(true)
        setIsLoading(false)

      }
    } catch (error) {
      console.error("Fehler beim Abrufen der daten:", error);
      setIsLoading(false)

    }
  };

  const handleReject = async (event: React.MouseEvent<HTMLButtonElement>) => {
    setIsLoading(true)
    event.preventDefault();
    const newFormValues = {
      ...formValues,
      checkboxStates: [true, true, true, true],
      state: 'rejected',
    };

    setFormValues(newFormValues);
    try {
      const res = await processBooking(newFormValues);

      if (!res.success) {
        setIsLoading(false)

        setError(res.message || 'Es ist ein Fehler bei der Buchung aufgetreten. Bitte versuchen Sie es erneut.');
      } else {
        setIsLoading(false)

        setIsSuccessPopupOpen(true);
      }
    } catch (error) {
      setIsLoading(false)

      console.error("Error fetching data:", error);
    }
  };
  const formatDaterec = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  if (!isOpen) return null;

  const handleClose = () => {
    onClose();
  };

  const handleCheckboxChange = (index: number) => {
    const updatedCheckboxStates = [...checkboxStates];
    updatedCheckboxStates[index] = !updatedCheckboxStates[index];
    setCheckboxStates(updatedCheckboxStates);

  };
  return (
    <Popup
      title={` Buchungsanfrage bearbeiten ${bookinglist.status}`}
      submitLabel={""}
      closeLabel={""}
      isWithButton={false}
      isOpen={isOpen}
      onClose={handleClose}
    >
      <form>
        {error && <ErrorFailed error={error} />}

        <div className={styles.form}>
          <div className={commonStyles.formGroupRow}>
            {bookinglist.recurrence === 'serial' ? (
              <>
                <div className={commonStyles.formGroup}>
                  <label>von</label>
                  <p>{formatDate(bookinglist.date)}</p>
                </div>
                <div className={commonStyles.formGroup}>
                  <label>bis</label>
                  <p>{bookinglist.recurrence_date_3 ? formatDate(bookinglist.recurrence_date_3) : ''}</p>
                </div>
              </>
            ) : (
              <div className={commonStyles.formGroup}>
                <label>Datum</label>
                <p>{formatDate(bookinglist.date)}</p>
              </div>
            )}
          </div>
          
          <div className={styles.formGroupCountainer}>
            <div className={commonStyles.formGroupRow}>
              <div className={commonStyles.formGroup}>
                <label>Kind</label>
                <div className={commonStyles.formGroupRow}>
                  <div className={styles.formGroupCountainer}>
                    <p>{bookinglist.kidName}</p>
                  </div>
                  <div className={styles.formGroupCountainer}>
                    <p>{bookinglist.age} Jahre</p>
                  </div>
                </div>
              </div>
              <div className={commonStyles.formGroup}>
                <label>Eltern Status</label>
                <div className={commonStyles.formGroupRow}>
                  <div className={styles.formGroupCountainer}>
                    <p>{profileStatusLabels[bookinglist.profile_status]}</p>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div className={commonStyles.formGroupRow}>
            <div className={commonStyles.formGroup}>
              <label>Block</label>
              <div className={commonStyles.formGroupRow}>
                <div className={styles.formGroupCountainer}>
                  <p>{bookinglist.start_time?.substring(0, 5)} - {bookinglist.end_time?.substring(0, 5)}</p>
                </div>
                <div className={styles.formGroupCountainer}>
                  <p>{bookinglist.recurrence === 'onetime' ? 'Einmalig' : 'Wöchentlich'}</p>
                </div>
              </div>
            </div>
            <div className={commonStyles.formGroup}>
              <label>Kategorie</label>
              <div className={commonStyles.formGroupRow}>
                <div className={styles.formGroupCountainer}>
                  <p>{bookinglist.category === 'care' ? 'Betreuung' : 'Eingewöhnung'}</p>
                </div>
              </div>
            </div>
          </div>

          {bookinglist.recurrence === 'serial' && (
            <div className={styles.recurrenceContainer}>
              <label className={styles.label}>Termine</label>
              <div className={styles.chaeckBoxCountainer}>
                {[0, 1, 2, 3].map((index) => {
                  const recurrenceDate = new Date(bookinglist[`recurrence_date_${index}` as keyof EmployBookingList]);
                  const baseDate = new Date(bookinglist.date);
                  const showRecurrenceDate = new Date(baseDate);
                  showRecurrenceDate.setDate(baseDate.getDate() + (index) * 7);

                  const isAvelible = bookinglist[`recurrence_date_${index}_status` as keyof EmployBookingList] !== ""
                    && bookinglist[`recurrence_date_${index}_status` as keyof EmployBookingList] !== "cancelledPending"
                    && bookinglist[`recurrence_date_${index}_status` as keyof EmployBookingList] !== "cancelledConfirmed";
                  const placesUnder3 = bookingData
                    ? bookingData.filter(
                      (booking) =>
                        booking.age < 3 && booking.work_time_slot_id.toString() === bookinglist.work_time_slot_id.toString() &&
                        (
                          (new Date(booking.date).toDateString() === recurrenceDate.toDateString() && booking.status === "confirmed" && booking.recurrence === "onetime") ||
                          (booking.recurrence === "serial" && (
                            ((booking.recurrence_date_0 && new Date(booking.recurrence_date_0).toDateString() === recurrenceDate.toDateString()) && booking.recurrence_date_0_status === "confirmed") ||
                            ((booking.recurrence_date_1 && new Date(booking.recurrence_date_1).toDateString() === recurrenceDate.toDateString()) && booking.recurrence_date_1_status === "confirmed") ||
                            ((booking.recurrence_date_2 && new Date(booking.recurrence_date_2).toDateString() === recurrenceDate.toDateString()) && booking.recurrence_date_2_status === "confirmed") ||
                            ((booking.recurrence_date_3 && new Date(booking.recurrence_date_3).toDateString() === recurrenceDate.toDateString()) && booking.recurrence_date_3_status === "confirmed"))
                          )
                        )
                    ).length
                    : 0;


                  const placesOver3 = bookingData
                    ? bookingData.filter(
                      (booking) =>
                        booking.age >= 3 && booking.work_time_slot_id.toString() === bookinglist.work_time_slot_id.toString() &&
                        (
                          (new Date(booking.date).toDateString() === recurrenceDate.toDateString() && booking.status === "confirmed" && booking.recurrence === "onetime") ||
                          (booking.recurrence === "serial" && (
                            ((booking.recurrence_date_0 && new Date(booking.recurrence_date_0).toDateString() === recurrenceDate.toDateString()) && booking.recurrence_date_0_status === "confirmed") ||
                            ((booking.recurrence_date_1 && new Date(booking.recurrence_date_1).toDateString() === recurrenceDate.toDateString()) && booking.recurrence_date_1_status === "confirmed") ||
                            ((booking.recurrence_date_2 && new Date(booking.recurrence_date_2).toDateString() === recurrenceDate.toDateString()) && booking.recurrence_date_2_status === "confirmed") ||
                            ((booking.recurrence_date_3 && new Date(booking.recurrence_date_3).toDateString() === recurrenceDate.toDateString()) && booking.recurrence_date_3_status === "confirmed"))
                          ))
                    ).length
                    : 0;

                  return (
                    <div key={index}>
                      <div className={styles.recurrenceCheckbox}>
                        {recurrenceDate !== null ? (
                          isAvelible ? (
                            <input
                              type="checkbox"
                              checked={checkboxStates[index]}
                              onChange={() => handleCheckboxChange(index)}
                            />
                          ) : (
                            <IoMdClose />
                          )
                        ) : (
                          <IoMdClose />
                        )}
                        <span>{formatDaterec(showRecurrenceDate)}</span>
                      </div>

                      {placesUnder3 !== 0 && (
                        <div className={styles.placeinfoLine}>
                          <div className={styles.placeinfoLabel}>
                            <div className={styles.placeNr}>{placesUnder3}</div>
                            {placesUnder3 === 1 ? "Platz" : "Plätze"}
                          </div>
                          <div>u 3 J</div>
                        </div>
                      )}

                      {placesOver3 !== 0 && (
                        <div className={styles.placeinfoLine}>
                          <div className={styles.placeinfoLabel}>
                            <div className={styles.placeNr}>{placesOver3}</div>
                            {placesOver3 === 1 ? "Platz" : "Plätze"}
                          </div>
                          <div>ü 3 J</div>
                        </div>
                      )}
                    </div>
                  );
                })}

              </div>
            </div>
          )}
          {bookinglist.note && <div className={commonStyles.formGroup}>
            <label>Bemerkung</label>
            <p>{bookinglist.note}</p>
          </div>}
          <div className={commonStyles.formGroup}>
            <h3>
              <label htmlFor="feedback">Mitarbeiter Bemerkung</label>
            </h3>
            <textarea
              id="feedback"
              name="feedback"
              value={formValues.feedback}
              onChange={handleInputChange}
              className={styles.textarea}
            />
          </div>

        </div>
        {
          <div className={styles.controllButtonContainer}>
            <button type="button" className={`${commonStyles.commonButton} ${commonStyles.backButton}`} onClick={onClose}>
              Abbrechen
            </button>
            <div className={styles.popupButtonContainer}>
              <button type="button" disabled={isLoading} className={`${commonStyles.commonButton} ${styles.rejectButton}`} onClick={handleReject}>

                {isLoading ? (
                  <div className={commonStyles.spinner}></div>
                ) : (
                  "Ablehnen"
                )}
              </button>
              <button type="button" disabled={isLoading} className={`${commonStyles.commonButton} ${commonStyles.submitButton}`} onClick={handleConfirm}>

                {isLoading ? (
                  <div className={commonStyles.spinner}></div>
                ) : (
                  "Zusagen"
                )}
              </button>
            </div>
          </div>}
      </form>
      <SuccessPopup isPopupOpen={isSuccessPopupOpen} onClose={() => {
        onClose();
        setIsSuccessPopupOpen(false);
      }} />
    </Popup>
  );
}

